import { ref, reactive, computed, toRefs, createApp, inject,provide } from "vue";
import {generateDownloadLink} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';
import { httpGet, httpPost } from "../api/http_caller.js";
import FallcoNotify  from 'fallco-frontend-framework/src/js/libs/notify.js';
import PreventiviIndex from "../pages/preventivi/preventivi-index.js";
import PreventiviTemplate from "../pages/preventivi/preventivi-template.json";
import tabsPreventivoJSON from "../pages/preventivi/tabs-preventivo.json";
import CategoriaImmobiliareJSON from "../pages/preventivi/json/immobiliare/preventivo.json";
import CategoriaSocietarioJSON from "../pages/preventivi/json/societario/preventivo.json";
import CategoriaFamigliaJSON from "../pages/preventivi/json/famiglia/preventivo.json";
import CategoriaAttiMortisCausaJSON from "../pages/preventivi/json/attimortiscausa/preventivo.json";
import CategoriaAltroJSON from "../pages/preventivi/json/altro/preventivo.json";
import moment from "moment";
import FormImmobiliareCasa from "../modules/preventivi/FormImmobiliareCasa.vue";
import FormImmobiliareCasaTerreno from "../modules/preventivi/FormImmobiliareCasaTerreno.vue";
import FormImmobiliareBeniCulturali from '../modules/preventivi/FormImmobiliareBeniCulturali.vue'
import FormImmobiliareTerreni from '../modules/preventivi/FormImmobiliareTerreni.vue'
import FormImmobiliarePermute from '../modules/preventivi/FormImmobiliarePermute.vue'
import FormImmobiliareDonazioniRisoluzioniAttiCostitutivi
  from '../modules/preventivi/FormImmobiliareDonazioniRisoluzioniAttiCostitutivi.vue'
import FormImmobiliareConferimenti from '../modules/preventivi/FormImmobiliareConferimenti.vue'
import FormImmobiliareMutuoSurroga from '../modules/preventivi/FormImmobiliareMutuoSurroga.vue'
import FormImmobiliareServitu from "../modules/preventivi/FormImmobiliareServitu.vue";
import FormImmobiliareDivisioni from "../modules/preventivi/FormImmobiliareDivisioni.vue";
import FormImmobiliareOperazioniIpoteche from "../modules/preventivi/FormImmobiliareOperazioniIpoteche.vue";
import FormSocietarioCostituzioni from "../modules/preventivi/FormSocietarioCostituzioni.vue";
import FormSocietarioCessioneQuote from "../modules/preventivi/FormSocietarioCessioneQuote.vue";
import FormSocietarioVerbaliDiAssemblea from "../modules/preventivi/FormSocietarioVerbaliDiAssemblea.vue";
import FormSocietarioScioglimentoSocieta from "../modules/preventivi/FormSocietarioScioglimentoSocieta.vue";
import FormSocietarioCessioneAziende from "../modules/preventivi/FormSocietarioCessioneAziende.vue";
import FormSocietarioAttiVari from "../modules/preventivi/FormSocietarioAttiVari.vue";
import FormSocietarioAffitto from "../modules/preventivi/FormSocietarioAffitto.vue";
import FormSocietarioScissioniFusioni from "../modules/preventivi/FormSocietarioScissioniFusioni.vue";
import FormFamigliaSeparazione from "../modules/preventivi/FormFamigliaSeparazione.vue";
import FormFamigliaFondoPatrimoniale from "../modules/preventivi/FormFamigliaFondoPatrimoniale.vue";
import FormFamigliaAttiMortisCausa from "../modules/preventivi/FormFamigliaAttiMortisCausa.vue";
import FormAltroProcure from "../modules/preventivi/FormAltroProcure.vue";
import FormAltroCessioniDiCrediti from "../modules/preventivi/FormAltroCessioniDiCreditii.vue";
import FormSocietarioVidimazioni from "../modules/preventivi/FormSocietarioVidimazioni.vue";
import FormAltroAccettazioneTacita from "../modules/preventivi/FormAltroAccettazioneTacita.vue";
import FormAltroEstratti from "../modules/preventivi/FormAltroEstratti.vue";
import FormAltroCertificazioni from "../modules/preventivi/FormAltroCertificazioni.vue";
import FormAltroEntiTerzoSettore from "../modules/preventivi/FormAltroEntiTerzoSettore.vue";
import {cloneDeep} from "lodash";
import FormImmobiliareAttiDichiarativi from "../modules/preventivi/FormImmobiliareAttiDichiarativi.vue";
import FormImmobiliareAltriTrasferimenti from "../modules/preventivi/FormImmobiliareAltriTrasferimenti.vue";
import DettaglioPreventivoHelper from "./../pages/preventivi/json/dettagliopreventivo/helper.json";

/**
 * Espone data e metodi per la gestione dei preventivi
 * @param props
 * @param data
 */
export function usePreventivo(props, data, router = null) {
  const formVisible = ref(true);
  const regimeFiscale = ref('ordinario');
  let preventivoCalcolato = ref(false);
  const renditaCatastale = ref(0);
  const renditaCatastaleTerreno = ref(0);
  const onorarioRepertorio = ref(0);
  const esito = ref(0);
  const valoreCompensoPrecedente = ref(0);
  const compensoValoreInziale = ref(0);
  /**
   * editMode è una variabile che indica se l'utente ha modificato i campi nella sezione Anticipazione del dettaglio Preventivo,
   * nel caso di true i totali sono da ricalcolare se false invece teniamo i valori che abbiamo ricevuto dalla chiamata.
   * @type {Ref<UnwrapRef<boolean>>}
   */
  const editMode = ref(false);
  const rispostaCalcolo = reactive({value: ''})
  const idPreventivo = ref('')
  const condizioniRequired = ref(false);
  const inputFiltro = reactive({
    ricerca: {value: '', name: 'filtro_ricerca', placeholder: 'Ricerca per parola chiave'}
  })
  let valoriDaAggiornare = reactive({})
  const cardPreventivi = reactive(PreventiviIndex)
  const templateData = reactive(PreventiviTemplate)
  const copiaTemplateData = cloneDeep(PreventiviTemplate);
  const preventivoTabsJSONData = ref(tabsPreventivoJSON);
  const readonlyStatus = ref(false);
  const ricalcoloPreventivoGenerato = ref(false);
  const totali = reactive({
    totale_anticipazioni: '',
    diritti: '',
    totale_imponibile: '',
    ritenuta_acconto: '',
    totale_preventivo_non_modificabile:''
  })
  const validazioneForm = reactive({
    data: {
      num:'',
      title: '',
      titoloCard:'',
      categoria: '',
      sottocategoria: '',
      form: '',
      action: '',
      url: '',
      preventivo_id:''
    }
  })
  const categoriaImmobiliare = reactive(CategoriaImmobiliareJSON)
  const copiaCategoriaImmobiliare = cloneDeep(CategoriaImmobiliareJSON);
  const categoriaSocietario = reactive(CategoriaSocietarioJSON)
  const copiaCategoriaSocietario = cloneDeep(CategoriaSocietarioJSON);
  const categoriaFamiglia = reactive(CategoriaFamigliaJSON);
  const categoriaAttiMortisCausa = reactive(CategoriaAttiMortisCausaJSON);
  const copiaCategoriaAttiMortisCausa = cloneDeep(CategoriaAttiMortisCausaJSON);
  const copiaCategoriaFamiglia = cloneDeep(CategoriaFamigliaJSON);
  const categoriaAltro = reactive(CategoriaAltroJSON);
  const copiaCategoriaAltro = cloneDeep(CategoriaAltroJSON);
  const preventivo = reactive({
    // lista di input che vengono utilizzati per calcolare il preventivo
    input: {
      iscrizione_repertorio: {value: '', required: false, type: 'valuta', isvalid: true},
      visura_ipotecaria: {value: '', required: false, type: 'valuta', isvalid: true},
      onorari: {value: '', required: false, type: 'valuta', isvalid: true},
      sconto: {value: '', required: false, type: 'valuta', isvalid: true},
      diritto_annuale_registro_imprese: {value: '', required: false, type: 'valuta', isvalid: true},
      diritti: {value: '', required: false, type: 'valuta', isvalid: true},
      altre_spese: {value: '', required: false, type: 'valuta', isvalid: true},
      data_intestazione: {
        value: templateData.dati_preventivo.Intestazione.template.data_intestazione.value,
        type: 'data',
        required: true,
        isvalid: true
      },
      luogo_intestazione: {
        value: templateData.dati_preventivo.Intestazione.template.luogo_intestazione.value,
        required: true,
        isvalid: true
      },
      oggetto_intestazione: {
        value: templateData.dati_preventivo.Intestazione.template.oggetto_intestazione.value,
        required: false
      },
      note_interne: {
        value: templateData.dati_preventivo.Intestazione.template.note_interne.value,
        required: false
      },
      inputHidden:{
        value: '',
        required: false
      },
      totale_imponibile_inziale:{
        value: '',
        required: false
      },
      totale_preventivo_iniziale:{
        value: '',
        required:false
      },
      diritto_annuale_registro_imprese_valore_iniziale:{
        value: '',
        required:false
      },
      /**
       * altre_spese_valore_iniziale è un oggetto di validazione utilizzato per capire se il valore del campo altre spese
       * è un dato passato al caricamento pagina (da un duplica o da un readonly), perchè in questo caso le anticipazioni devono fare un calcolo diverso
       */
      altre_spese_valore_iniziale: {value: '', required: false, type: 'valuta', isvalid: true},
    }
  })
  const valore_equo_compenso_calcolato_spese_generali = ref(0);
  const valore_equo_compenso_calcolato = ref(0);
  const validazioneAltreSpese = reactive({
    input: {
      label_altre_spese: {value: 'Altre spese', required: true}
    }
  })
  const validazioneAltriImponibili = reactive({
    input: {
      label_diritti: {value: 'Altri imponibili', required: true}
    }
  })
  const validazioneCondizioni = reactive({
    input: {
      condizioni: {value: templateData.dati_preventivo.Condizioni.template.condizioni.value, required: false}
    }
  })
  const validazioneEquoCompenso = reactive({
    input: {
      equo_compenso_calcolato: {value: templateData.dati_preventivo.Imponibili.template.equo_compenso_calcolato.value, required: true},
      valore_equo_compenso_calcolato: {value: '', required: false,},
      valore_equo_compenso_calcolato_spese_generali: {value: '', required: false}
    }
  })
  const validazioneArrotondamento = reactive({
    input: {
      arrotondamento: {value: '', required: false, type: 'valuta', isvalid: true},
      arrotondamento_su_compenso: {value: '', required: false, type: 'valuta', isvalid: true}
    }
  })
  const filtroCategorie = reactive({
    input: {
      filtro_ricerca: {value: '', required: false}
    }
  })
  /**
   * categorieValidazione è un oggetto reattivo che racchiude la validazione dei vari campi delle seguenti sezioni:
   *
   * Dettaglio Preventivo
   *
   * Form di calcolo dei preventivi (per tutte le categorie, immobiliare, societario, ecc)
   *
   * Filtro di ricerca
   *
   * Es: categorieValidazione.preventivo racchiude la validazione degli input presenti nel dettaglio preventivo
   */
  const categorieValidazione = reactive({
    // categorie principali
    categoriaImmobiliare: categoriaImmobiliare,
    categoriaSocietario: categoriaSocietario,
    categoriaFamiglia: categoriaFamiglia,
    categoriaAttiMortisCausa: categoriaAttiMortisCausa,
    categoriaAltro: categoriaAltro,
    preventivo: preventivo,
    filtroCategorie: filtroCategorie,
  })
  const codiceRiferimentoPreventivo = ref('');
  const alertRicalcolo = ref(false);
  const arrotondamentoCalcolato = ref(false)
  const arrotondamentoMaggioreDelTotale = ref(false)
  const arrotondamentoCompensoMaggiore = ref(true);
  const compensoDaAggiornareDaArrotondamento = ref(false);
  const compensoModificato = ref(false);
  const totaleImponibileCalcolato = ref(0);
  const datiPreventivoReadonly = ref({});
  const datiPreventivoDuplica = ref({});
  const duplicaStatus = ref(false);
  const testoCompilazione = ref('')
  const tabellaEquoCompensoSelezionata = ref('');
  const totaleImponibilePerTabellaCD = ref(true);
  const procediAlCalcoloArrotondamento = ref(true);

  function getUrlParamPreventivo(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let params = urlParams.get('preventivo');
    params = params.slice(0, params.indexOf('|'));
    return params
  }

  async function salvaPreventivo(){
    // Alla generazione del pdf aggiungo al json i dati del form
    let categoria = '';
    switch (validazioneForm.data.categoria) {
      case "categoriaImmobiliare":
        categoria = "Immobiliare";
        break;
      case "categoriaSocietario":
        categoria = "Societario";
        break;
      case "categoriaFamiglia":
        categoria = "Famiglia";
        break;
      case "categoriaAttiMortisCausa":
        categoria = "Atti mortis causa";
        break;
      case "categoriaAltro":
        categoria = "Altro";
        break;
    }
    templateData.preventivo_id = idPreventivo.value || '';
    templateData.codice = validazioneForm.data.num;
    templateData.categoria = categoria;
    templateData.sottocategoria = validazioneForm.data.sottocategoria;
    templateData.titolo = validazioneForm.data.title;
    templateData.titoloCard = validazioneForm.data.titoloCard ? validazioneForm.data.titoloCard : getUrlParamPreventivo();
    templateData.url = validazioneForm.data.url;
    let parametriJSON = JSON.stringify(templateData)
    let preventivo_salvato = await httpPost('Preventivi', 'save_preventivo', {id:idPreventivo.value || '',parametri:parametriJSON}, {
      messages: 'error',
    });
    if (preventivo_salvato.esito == 'ok') {
      idPreventivo.value = preventivo_salvato.preventivo_id;
      if(codiceRiferimentoPreventivo.value == '') {
        codiceRiferimentoPreventivo.value = 'Riferimento: '+ preventivo_salvato.numero + '/' + preventivo_salvato.anno;
      }
      FallcoNotify.success('Preventivo Salvato');
      ricalcoloPreventivoGenerato.value = true;
    }
  }

  function formattaStringaPercentuale(valore) {
    if (typeof valore == 'string') {
      valore = Number(valore)
    }

    if (valore != undefined) {
      valore = valore.toLocaleString('it-IT') + '%'
      return valore
    }
  }

  function onSubmittedForm(event, response) {
    renditaCatastale.value = response.totale_rendita_catastale || '';
    renditaCatastaleTerreno.value = response.totale_rendita_catastale_terreno || '';
    onorarioRepertorio.value = response.onorario_repertorio || '';
    esito.value = response.esito || '';
    let regime_fiscale = response.regime_fiscale || 'ordinario';

    preventivoCalcolato.value = true
    if (response.esito) {
      delete response.esito
    }
    if (response.message) {
      delete response.message
    }

    if(response.equo_compenso_calcolato) {
      valore_equo_compenso_calcolato.value = response.equo_compenso_calcolato.valore_equo_compenso_calcolato;
      valore_equo_compenso_calcolato_spese_generali.value = response.equo_compenso_calcolato.valore_equo_compenso_calcolato_spese_generali;
    }

    // Al submit del preventivo svuotiamo il campo altre spese valore iniziale per evitare errori nel ricalcolo in pagina
    if(preventivo.input.altre_spese_valore_iniziale.value !== ''){
      preventivo.input.altre_spese_valore_iniziale.value = ''
    }

    let arrayDefaultTemplate = []

    // Controlliamo se risulta necessario rimuovere/modificare
    // il json di default - varia in base alla tipologia di preventivo scelto
    rispostaCalcolo.value = response
    let campiPreventivo = Object.keys(rispostaCalcolo.value)

    // generiamo l'array con tutte le voci del tamplate
    let keyTemplate = Object.keys(templateData.dati_preventivo)
    keyTemplate.forEach((singlecategory) => {
      let categoriaDiRiferimento = templateData.dati_preventivo[singlecategory].template
      let arraySubcategories = Object.keys(categoriaDiRiferimento)
      arraySubcategories.forEach((item) => {
        arrayDefaultTemplate.push(item)
      })

    })

    valoriDaAggiornare = arrayDefaultTemplate.filter(i => campiPreventivo.indexOf(i) !== -1)

    // se selezionato nell'equo compenso la tabella D/E rimuove i campi cnn e iscrizione repertorio
    // (per ora le tabelle sono solo nei preventivi 1.5.20/1.5.30)
    if(tabellaEquoCompensoSelezionata.value === 'surroga_convenzionata' ||
      tabellaEquoCompensoSelezionata.value === 'quietanza_di_surroga_convenzionata' ){
      valoriDaAggiornare = valoriDaAggiornare.filter(item => item !== 'iscrizione_repertorio' && item !== 'cassa_nazionale_notariato');
    }

    // Vado a inserire il valore e ad aggiornare i dati
    for (let i = 0; i < Object.keys(response).length; i++) {

      let listaCategoriePrincipali = Object.keys(templateData.dati_preventivo)
      listaCategoriePrincipali.forEach((categoria, index) => {

        let item = templateData.dati_preventivo[categoria]
        if (!item.template) {
          return
        }
        let templatecategoria = Object.keys(item.template)
        templatecategoria.forEach((subitem) => {
          if (valoriDaAggiornare.includes(subitem)) {
            // se campo statico controlla

            let inputModificabili = ['iscrizione_repertorio', 'visura_ipotecaria', 'sconto', 'diritto_annuale_registro_imprese']
            let singleTemplate = templateData.dati_preventivo[categoria].template[subitem]
            if (inputModificabili.includes(subitem)) {
              if(subitem === 'diritto_annuale_registro_imprese'){
                categorieValidazione.preventivo.input.diritto_annuale_registro_imprese_valore_iniziale.value = preventivo.input[subitem].value
              }

              // se selezionato nell'equo compenso la tabella D/E azzerare la visura ipotecaria
              // (per ora le tabelle sono solo nei preventivi 1.5.20/1.5.30)
              if ((tabellaEquoCompensoSelezionata.value === "surroga_convenzionata" ||
                  tabellaEquoCompensoSelezionata.value === "quietanza_di_surroga_convenzionata") &&
                subitem === "visura_ipotecaria" ){
                preventivo.input[subitem].value = 0;
              } else {
                preventivo.input[subitem].value = response[subitem]
              }
            } else {
              if (singleTemplate.name === 'totale_anticipazioni') {
                totali.totale_anticipazioni = response[subitem];
              }

              if (singleTemplate.name === 'totale_imponibile') {
                totali.totale_imponibile = response[subitem];
                categorieValidazione.preventivo.input.totale_imponibile_inziale.value = response[subitem];
              }

              if (singleTemplate.name === 'totale_preventivo') {
                totali.totale_preventivo_non_modificabile = response[subitem];
              }

              if (singleTemplate) {
                singleTemplate.value = response[subitem]
              }
            }
          } else {
            let sezioniStatiche = ['data_intestazione', 'altre_spese', 'onorari', 'diritti', 'oggetto_intestazione', 'note_interne', 'totale_preventivo', 'condizioni', 'sconto', 'arrotondamento', 'arrotondamento_su_compenso', 'luogo_intestazione','totale_imponibile','iva_22','totale_anticipazioni']
              // if(regime_fiscale !== 'ordinario'){
              //   const index = sezioniStatiche.indexOf('iva_22');
              //   sezioniStatiche.splice(index, 1);
              // }
            if (!sezioniStatiche.includes(subitem)) {
              delete templateData.dati_preventivo[categoria].template[subitem]
            }
          }
        })

      })

    }
    // Compilo i dati Intestazione
    preventivo.input.oggetto_intestazione.value = 'Preventivo per ' + validazioneForm.data.title;
    preventivo.input.data_intestazione.value = moment().format('YYYY-MM-DD');
    preventivo.input.luogo_intestazione.value = templateData.dati_preventivo.Intestazione.template.luogo_intestazione.value;
    preventivo.input.note_interne.value = templateData.dati_preventivo.Intestazione.template.note_interne.value;
  }

  function updateDatiCalcolo(categoriaValidazione, formData, ricalcolo) {
    if(ricalcolo){
    readonlyStatus.value = false;
    validazioneArrotondamento.input.arrotondamento.value = '';
    validazioneArrotondamento.input.arrotondamento_su_compenso.value = '';
    templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value = '';
    templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento_su_compenso.value = '';
    }
    let validazioneDatiCalcolo = categoriaValidazione[formData.categoria][formData.sottocategoria][formData.form];
    tabellaEquoCompensoSelezionata.value = validazioneDatiCalcolo.tipologia_tabella_calcolo.value;
    let keysDatiCalcolo = Object.keys(validazioneDatiCalcolo);
    keysDatiCalcolo.forEach((key, index) => {
      templateData.dati_calcolo.template[key] = {
        name: key,
        value: validazioneDatiCalcolo[key].value,
        label: validazioneDatiCalcolo[key].label,
        type: validazioneDatiCalcolo[key].type || ""
      };
    });
  }

  function onResetForm(data, params, copiaForm) {

    let campiForm = Object.keys(data[params.categoria][params.sottocategoria][params.form]);
    campiForm.forEach((item) => {

      if(item.includes('tab_')){
        data[params.categoria][params.sottocategoria][params.form][item].value = 0;
        return;
      }

      if(item === 'tipo_preventivo'){
        return;
      }
      data[params.categoria][params.sottocategoria][params.form][item].value = copiaForm[item].value;
      data[params.categoria][params.sottocategoria][params.form][item].required = copiaForm[item].required;
      data[params.categoria][params.sottocategoria][params.form][item].disabled = copiaForm[item].disabled;
      data[params.categoria][params.sottocategoria][params.form][item].label = copiaForm[item].label;
    });

    preventivoCalcolato.value = false
    preventivo.input.altre_spese.value = '';
    preventivo.input.diritti.value = '';
    preventivo.input.onorari.value = '';
    preventivo.input.sconto.value = '';
    validazioneArrotondamento.input.arrotondamento.value = '';
    preventivo.input.iscrizione_repertorio.value = '';
    preventivo.input.visura_ipotecaria.value = '';
    preventivo.input.diritto_annuale_registro_imprese.value = '';
    validazioneCondizioni.input.condizioni.value = templateData.dati_preventivo.Condizioni.template.condizioni.value;

    // preventivo.input.data_intestazione.value = '';
    // preventivo.input.luogo_intestazione.value = '';
    // preventivo.input.oggetto_intestazione.value = '';
    editMode.value = false;
    templateData.dati_preventivo = cloneDeep(copiaTemplateData.dati_preventivo);
    formVisible.value = false;
  }

  function openForm(data, index) {

    // formVisible.value = false;
    let url =  (typeof data.url === 'object' ? data.url[0]:data.url)
    validazioneForm.data.num = data.num
    validazioneForm.data.title = data.title
    validazioneForm.data.form = data.form
    validazioneForm.data.sottocategoria = data.sottocategoria
    validazioneForm.data.categoria = data.categoria
    validazioneForm.data.action = data.action
    validazioneForm.data.url = url
    validazioneForm.data.titoloCard = index;

    setTimeout(() => {
      router.push({ path: '/preventivi', query: {preventivo: index + '|'+url}})
    }, 100)

  }

  function formatterSomma(num) {
    return parseFloat(Number(decodifica_valore(num)).toFixed(2));
  }

  function formatterValore(num) {
    return codifica_valore(Number(num).toFixed(2))
  }

  function formatterValoreAliquota(num) {
    return codifica_valore(Number(num).toFixed(3))
  }

  function decodifica_valore(value) {
    var str = new String(value);
    str = str.replace(",", ".");
    return str;
  }

  function codifica_valore(value) {
    var str = new String(value);
    let x;
    str = str.replace(".", ",");
    str += '';
    x = str.split(',');
    let x1 = x[0];
    let x2 = x.length > 1 ? ',' + x[1] : ',00';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
  }

  function stringToNumber(stringValue) {
    stringValue = stringValue.trim();
    var result = stringValue.replace(/[^0-9]/g, '');
    if (/[,\.]\d{2}$/.test(stringValue)) {
      result = result.replace(/(\d{2})$/, '.$1');
    }
    return parseFloat(result);
  }

  function disabilitaRisultaticalcolo() {
    if (preventivoCalcolato.value === true) {
      preventivo.input.altre_spese.value = '';
      preventivo.input.diritti.value = '';
      preventivo.input.onorari.value = '';
      preventivo.input.sconto.value = '';
      preventivo.input.iscrizione_repertorio.value = '';
      preventivo.input.visura_ipotecaria.value = '';
      preventivo.input.diritto_annuale_registro_imprese.value = '';
      arrotondamentoCalcolato.value = false
      validazioneCondizioni.input.condizioni.value = templateData.dati_preventivo.Condizioni.template.condizioni.value;
      validazioneArrotondamento.input.arrotondamento.value = '';
      templateData.dati_preventivo = cloneDeep(copiaTemplateData.dati_preventivo);
      formVisible.value = false;
    }
    preventivoCalcolato.value = false;
  }

  function getCopiaCategoria(validazioneForm) {
    let categoria = validazioneForm.data.categoria;
    let riferimento = '';
    switch (categoria) {
      case 'categoriaImmobiliare':
        riferimento = copiaCategoriaImmobiliare[validazioneForm.data.sottocategoria][validazioneForm.data.form];
        break;
      case 'categoriaSocietario':
        riferimento = copiaCategoriaSocietario[validazioneForm.data.sottocategoria][validazioneForm.data.form];
        break;
      case 'categoriaFamiglia':
        riferimento = copiaCategoriaFamiglia[validazioneForm.data.sottocategoria][validazioneForm.data.form];
        break;
      case 'categoriaAttiMortisCausa':
        riferimento = copiaCategoriaAttiMortisCausa[validazioneForm.data.sottocategoria][validazioneForm.data.form];
        break;
      case 'categoriaAltro':
        riferimento = copiaCategoriaAltro[validazioneForm.data.sottocategoria][validazioneForm.data.form];
        break;
    }
    return riferimento
  }

  function getLabelItem(subItem, renditaCatastale, renditaCatastaleTerreno, onorarioRepertorio, esito) {

    if (esito == 'ok' && renditaCatastale != '' && subItem.name === 'valore_catastale_calcolato') {
      templateData.dati_preventivo['Parametri di Calcolo'].template.valore_catastale_calcolato.label = subItem.label.replace('**', codifica_valore(renditaCatastale));
    }

    if(esito == 'ok' && renditaCatastale == '' && subItem.name === 'valore_catastale_calcolato'){
      templateData.dati_preventivo['Parametri di Calcolo'].template.valore_catastale_calcolato.label = subItem.label.replace(/ *\([^)]*\) */g, "");
    }

    if (esito == 'ok' && renditaCatastaleTerreno && subItem.name === 'valore_catastale_terreno_calcolato') {
      templateData.dati_preventivo['Parametri di Calcolo'].template.valore_catastale_terreno_calcolato.label = subItem.label.replace('**', codifica_valore(renditaCatastaleTerreno));
    }

    if (esito == 'ok'  && subItem.name === 'cassa_nazionale_notariato') {
      templateData.dati_preventivo['Imponibili'].template.cassa_nazionale_notariato.label = subItem.label.replace('**', codifica_valore(onorarioRepertorio));
    }

    if (esito == 'ok'  && subItem.name === 'contributi_addizionali') {
      templateData.dati_preventivo['Imponibili'].template.contributi_addizionali.label = subItem.label.replace('**', codifica_valore(onorarioRepertorio));
    }

    return subItem.label;
  }

  function getComponentName(subCategory){
    let name = '';
    switch (subCategory){
      case 'sottocategoriaCasa':
        name = FormImmobiliareCasa;
        break;
      case 'sottocategoriaMutuoSurroga':
        name = FormImmobiliareMutuoSurroga;
        break;
      case 'sottocategoriaCasaTerreno':
        name = FormImmobiliareCasaTerreno;
        break;
      case 'sottocategoriaBeniCulturali':
        name = FormImmobiliareBeniCulturali;
        break;
      case 'sottocategoriaTerreni':
        name = FormImmobiliareTerreni;
        break;
      case 'sottocategoriaPermute':
        name = FormImmobiliarePermute;
        break;
      case 'sottocategoriaDonazioniRisoluzioniAttiCostitutivi':
        name = FormImmobiliareDonazioniRisoluzioniAttiCostitutivi;
        break;
      case 'sottocategoriaConferimenti':
        name = FormImmobiliareConferimenti;
        break;
      case 'sottocategoriaServitu':
        name = FormImmobiliareServitu;
        break;
      case 'sottocategoriaDivisioni':
        name = FormImmobiliareDivisioni;
        break;
      case 'sottocategoriaOperazioniIpoteche':
        name = FormImmobiliareOperazioniIpoteche;
        break;
      case 'sottocategoriaCostituzione':
        name = FormSocietarioCostituzioni;
        break;
      case 'sottocategoriaCessioneQuote':
        name = FormSocietarioCessioneQuote;
        break;
      case 'sottocategoriaVerbaliDiAssemblea':
        name = FormSocietarioVerbaliDiAssemblea;
        break;
      case 'sottocategoriaScioglimentoSocieta':
        name = FormSocietarioScioglimentoSocieta;
        break;
      case 'sottocategoriaCessioneAziende':
        name = FormSocietarioCessioneAziende;
        break;
      case 'sottocategoriaVidimazioni':
        name = FormSocietarioVidimazioni;
        break;
      case 'sottocategoriaAffittoAzienda':
        name = FormSocietarioAffitto;
        break;
      case 'sottocategoriaSeparazione':
        name = FormFamigliaSeparazione;
        break;
      case 'sottocategoriaFondoPatrimoniale':
        name = FormFamigliaFondoPatrimoniale;
        break;
      case 'sottocategoriaAttiMortisCausa':
        name = FormFamigliaAttiMortisCausa;
        break;
      case 'sottocategoriaProcure':
        name = FormAltroProcure;
        break;
      case 'sottocategoriaAccettazioneTacita':
        name = FormAltroAccettazioneTacita;
        break;
      case 'sottocategoriaEstratti':
        name = FormAltroEstratti;
        break;
      case 'sottocategoriaCertificazioni':
        name = FormAltroCertificazioni;
        break;
      case 'sottocategoriaTrasferimentiAlConiuge':
        name = FormFamigliaSeparazione;
        break;
      case 'sottocategoriaAttiVari':
        name = FormSocietarioAttiVari;
        break;
      case 'sottocategoriaScissioniFusioni':
        name = FormSocietarioScissioniFusioni;
        break;
      case 'sottocategoriaAttiDichiarativi':
        name = FormImmobiliareAttiDichiarativi;
        break;
      case 'sottocategoriaAltriTrasferimenti':
        name = FormImmobiliareAltriTrasferimenti;
        break;
      case 'sottocategoriaEntiDelterzoSettoreAltriEntiDelLibroPrimoCC':
        name = FormAltroEntiTerzoSettore;
        break;
      case 'sottocategoriaVari':
        name = FormAltroCessioniDiCrediti;
        break;
    }
    return name;
  }

  /**
   * Funzione che richiamata al watch, aggiorna i valori presenti nel json con il nuovo valore inserito dall'utente
   * Fa riferimento solo agli input modificabili nella sezione dettaglio preventivo
   * @method aggiornaJsonDaInputDettaglioPreventivo
   * @param jsonData
   * @param newValue
   */
  function aggiornaJsonDaInputDettaglioPreventivo(newValue) {
    // ciclo per avere il nome dei nuovi valori passati
    Object.keys(newValue).forEach((inputName) => {
      // ciclo per avere il nome delle categorie presenti nel json
      Object.keys(templateData.dati_preventivo).forEach((categoryName) => {
        // controllo se all'interno corrisponde il nome del campo da aggiornare
        if (templateData.dati_preventivo[categoryName].template[inputName]) {
          // se l'input da aggiornare è onorari aggiungiamo un controllo e aggiorniamo la variabile reattiva: valore compenso precedente
          if (inputName === 'onorari') {
            if (valoreCompensoPrecedente.value != newValue.onorari.value) {
              valoreCompensoPrecedente.value = controlloFormatoDiCalcoloWatch(newValue.onorari);
            }
          }
          templateData.dati_preventivo[categoryName].template[inputName].value = newValue[inputName].value;
        }
      })
    })
  }

  function calcoloTotaleAnticipazioniEdit(jsonData,newValue){
    // se presente altre_spese_valore_inziale, il valore è caricato da una chiamata (in caso di readonly o duplica)
    let totaleCalcolo = 0;
    if (categorieValidazione.preventivo.input.altre_spese_valore_iniziale &&
      categorieValidazione.preventivo.input.altre_spese_valore_iniziale.value != '') {
      let totaleAnticipazioniSenzaSpese = totali.totale_anticipazioni - categorieValidazione.preventivo.input.altre_spese_valore_iniziale.value
      let dirittoAnnuale = 0;
      if (jsonData.Anticipazioni.template.diritto_annuale_registro_imprese) {
        dirittoAnnuale = controlloFormatoDiCalcoloWatch(jsonData.Anticipazioni.template.diritto_annuale_registro_imprese)
      }
      totaleCalcolo = totaleAnticipazioniSenzaSpese + dirittoAnnuale + controlloFormatoDiCalcoloWatch(jsonData.Anticipazioni.template.altre_spese)

    } else {
      totaleCalcolo = totali.totale_anticipazioni + controlloFormatoDiCalcoloWatch(newValue.diritto_annuale_registro_imprese) + controlloFormatoDiCalcoloWatch(newValue.altre_spese)
    }
    return totaleCalcolo;
  }

  function calcoloTotaleImponibili(jsonData,newValue){
    let calcoloTotale = 0;
      let onorario = controlloFormatoDiCalcoloWatch(newValue.onorari);
      let sconto = controlloFormatoDiCalcoloWatch(newValue.sconto);
      let diritti = controlloFormatoDiCalcoloWatch(newValue.diritti);
      let visura = controlloFormatoDiCalcoloWatch(newValue.visura_ipotecaria);
      let iscrizione_repertorio = controlloFormatoDiCalcoloWatch(newValue.iscrizione_repertorio);
      let cnn = jsonData.Imponibili.template.cassa_nazionale_notariato ? jsonData.Imponibili.template.cassa_nazionale_notariato.value : 0;
      let contributi_addizionali = jsonData.Imponibili.template.contributi_addizionali ? jsonData.Imponibili.template.contributi_addizionali.value : 0;
      calcoloTotale = (diritti + iscrizione_repertorio + onorario + visura + cnn + contributi_addizionali - sconto)

    if(calcoloTotale === 0 && (tabellaEquoCompensoSelezionata.value === "surroga_convenzionata" ||
      tabellaEquoCompensoSelezionata.value === "quietanza_di_surroga_convenzionata")){
      calcoloTotale = totali.totale_imponibile
    }

    return calcoloTotale;
  }

  function calcoloIvaTotaleImponibile(jsonData){
    let calcoloIva = 0;
    calcoloIva = (jsonData.Riepilogo.template.totale_imponibile.value * 22) / 100
    return calcoloIva;
  }

  function calcoloRitenutaAcconto(){
    let calcoloRitenuta = 0;
    templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20.value = (templateData.dati_preventivo.Riepilogo.template.totale_imponibile.value * 20) / 100
    calcoloRitenuta = templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20.value
    return calcoloRitenuta;
  }

  /**
   * Funzione che controlla il tipo di valore passato, assicurandosi che  non sia una stringa per evitare blocchi
   * o errori nel calcolo del preventivo
   * @param valore
   */
  function controlloFormatoDiCalcoloWatch(valore){
    let valore_corretto = formatterSomma(typeof valore.value == 'string' ? valore.value.replace('€', '') : valore.value);
    return valore_corretto;
  }

  /**
   * Funzione che viene richiamata al watch del duplica e dell'apri preventivo, carica i dati che vengono passati dalla chiamata
   * @param newValue
   * @param readonly
   */
  function aggiornamentoDatiPreventivo(newValue, readonly) {
    const dati_calcolo = newValue.data.payload.dati_calcolo.template;
    const dati_caricati_dal_preventivo = newValue.data.payload.dati_preventivo;
    // carichiamo nel templateData il file ritornato dal backend per eliminare i campi non necessari
    if (readonly === false) {
      templateData.dati_calcolo = newValue.data.payload.dati_calcolo;
    }
    templateData.dati_preventivo = dati_caricati_dal_preventivo;
    // sezione a destra del preventivo
    // dati intestazione sempre presenti
    categorieValidazione.preventivo.input.luogo_intestazione.value = dati_caricati_dal_preventivo['Intestazione'].template.luogo_intestazione.value;
    categorieValidazione.preventivo.input.note_interne.value = dati_caricati_dal_preventivo['Intestazione'].template.note_interne.value;
    let dataFormatter = moment(newValue.data.created_at, 'DD/MM/YYYY hh:mm:ss').format('YYYY-MM-DD')
    categorieValidazione.preventivo.input.data_intestazione.value = dataFormatter;
    categorieValidazione.preventivo.input.data_intestazione.isvalid = true;
    categorieValidazione.preventivo.input.oggetto_intestazione.value = dati_caricati_dal_preventivo['Intestazione'].template.oggetto_intestazione.value;
    // controllati e caricati i campi anticipazioni
    if (dati_caricati_dal_preventivo['Anticipazioni'].template.altre_spese) {
      categorieValidazione.preventivo.input.altre_spese_valore_iniziale.value = dati_caricati_dal_preventivo['Anticipazioni'].template.altre_spese.value;
      categorieValidazione.preventivo.input.altre_spese.value = dati_caricati_dal_preventivo['Anticipazioni'].template.altre_spese.value;
      validazioneAltreSpese.input.label_altre_spese.value = dati_caricati_dal_preventivo['Anticipazioni'].template.altre_spese.label;
    }
    if (dati_caricati_dal_preventivo['Anticipazioni'].template.diritto_annuale_registro_imprese) {
      categorieValidazione.preventivo.input.diritto_annuale_registro_imprese.value = dati_caricati_dal_preventivo['Anticipazioni'].template.diritto_annuale_registro_imprese.value;
    }
    // controllati e caricati i campi imponibili
    if (dati_caricati_dal_preventivo['Imponibili'].template.iscrizione_repertorio) {
      categorieValidazione.preventivo.input.iscrizione_repertorio.value = dati_caricati_dal_preventivo['Imponibili'].template.iscrizione_repertorio.value;
    }
    if (dati_caricati_dal_preventivo['Imponibili'].template.visura_ipotecaria) {
      categorieValidazione.preventivo.input.visura_ipotecaria.value = dati_caricati_dal_preventivo['Imponibili'].template.visura_ipotecaria.value;
    }
    if (dati_caricati_dal_preventivo['Imponibili'].template.diritti) {
      categorieValidazione.preventivo.input.diritti.value = dati_caricati_dal_preventivo['Imponibili'].template.diritti.value;
      validazioneAltriImponibili.input.label_diritti.value = dati_caricati_dal_preventivo['Imponibili'].template.diritti.label;
    }
    if (dati_caricati_dal_preventivo['Imponibili'].template.sconto) {
      categorieValidazione.preventivo.input.sconto.value = dati_caricati_dal_preventivo['Imponibili'].template.sconto.value;
    }
    if (dati_caricati_dal_preventivo['Imponibili'].template.onorari) {
      valoreCompensoPrecedente.value = dati_caricati_dal_preventivo['Imponibili'].template.onorari.value;
      categorieValidazione.preventivo.input.onorari.value = dati_caricati_dal_preventivo['Imponibili'].template.onorari.value;
      compensoValoreInziale.value = dati_caricati_dal_preventivo['Imponibili'].template.onorari.value;
    }
    if (dati_caricati_dal_preventivo['Imponibili'].template.equo_compenso_calcolato) {
      validazioneEquoCompenso.input.equo_compenso_calcolato.value = dati_caricati_dal_preventivo['Imponibili'].template.equo_compenso_calcolato.value;

      if(formatterSomma(dati_caricati_dal_preventivo['Imponibili'].template.onorari.value) == formatterSomma(dati_caricati_dal_preventivo['Imponibili'].template.equo_compenso_calcolato.value.valore_equo_compenso_calcolato)){
        validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = 1;
      } else if(formatterSomma(dati_caricati_dal_preventivo['Imponibili'].template.onorari.value) == formatterSomma(dati_caricati_dal_preventivo['Imponibili'].template.equo_compenso_calcolato.value.valore_equo_compenso_calcolato_spese_generali)){
        validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = 1;
      } else{
        validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = '';
        validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = '';
      }

      valore_equo_compenso_calcolato.value = validazioneEquoCompenso.input.equo_compenso_calcolato.value.valore_equo_compenso_calcolato;
      valore_equo_compenso_calcolato_spese_generali.value = validazioneEquoCompenso.input.equo_compenso_calcolato.value.valore_equo_compenso_calcolato_spese_generali;
    }

    // controllati e caricati i campi condizioni
    if (dati_caricati_dal_preventivo['Condizioni'].template.condizioni) {
      if(dati_caricati_dal_preventivo['Condizioni'].template.condizioni.value === 'condizioni_standard'){
        // controllo necessario per avere il testo selezionato in precedenza, aggiornando "Condizioni" da select a textarea,
        // se il valore precedentemente salvato corrisponde alla option era condizioni_standard, inserisco il testo statico che era presente,
        // altrimenti proseguo con il testo personalizzato.
        validazioneCondizioni.input.condizioni.value = "Ai sensi della vigente normativa le comunichiamo i dati relativi all'assicurazione R.C. professionale stipulata tra il Consiglio Nazionale del Notariato e Società Reale Mutua di Assicurazioni, polizza n. 2024032579295";
      } else {
        validazioneCondizioni.input.condizioni.value = dati_caricati_dal_preventivo['Condizioni'].template.condizioni.value;
      }
    }

    if (dati_caricati_dal_preventivo['Totale Preventivo'].template.arrotondamento) {
      if (readonly) {
        validazioneArrotondamento.input.arrotondamento.value = dati_caricati_dal_preventivo['Totale Preventivo'].template.arrotondamento.value;
      }
      if (dati_caricati_dal_preventivo['Totale Preventivo'].template.arrotondamento.value != '') {
        templateData.dati_preventivo['Totale Preventivo'].template.totale_preventivo.value = dati_caricati_dal_preventivo['Totale Preventivo'].template.arrotondamento.value;
      }
    }

    totali.totale_anticipazioni = templateData.dati_preventivo.Riepilogo.template.totale_anticipazioni.value;
    totali.totale_imponibile = templateData.dati_preventivo.Riepilogo.template.totale_imponibile.value;

    //sezione a sinistra del preventivo
    let validazioneDatiCalcolo = categorieValidazione[validazioneForm.data.categoria][validazioneForm.data.sottocategoria][validazioneForm.data.form];
    let keysFormCalcolo = Object.keys(validazioneDatiCalcolo);
    keysFormCalcolo.forEach((dato) => {
      if (dati_calcolo[dato]) {
        validazioneDatiCalcolo[dato].value = dati_calcolo[dato].value;
      }
    });
  }

  function calcoloTotaleImponibiliDaCompenso(jsonData,compenso){
   let calcoloTotale = formatterSomma(jsonData['Imponibili'].template.cassa_nazionale_notariato ? jsonData['Imponibili'].template.cassa_nazionale_notariato.value : 0) +
    formatterSomma(jsonData['Imponibili'].template.iscrizione_repertorio ? jsonData['Imponibili'].template.iscrizione_repertorio.value : 0) +
    formatterSomma(jsonData['Imponibili'].template.visura_ipotecaria ? jsonData['Imponibili'].template.visura_ipotecaria.value : 0) +
    formatterSomma(compenso.value ? compenso.value : 0) +
    formatterSomma(jsonData['Imponibili'].template.diritti ? jsonData['Imponibili'].template.diritti.value : 0) -
    formatterSomma(jsonData['Imponibili'].template.sconto ? jsonData['Imponibili'].template.sconto.value : 0);
  return calcoloTotale;
  }

  function calcoloDifferenzaImponibile(jsonData, differenzaArrotondamento,regime_fiscale){
    let calcoloTotale = 0;
    if(regime_fiscale == 'ordinario') {
      // se il regime fiscale è ordinario teniamo in considerazione la ritenuta e l'iva
      if (jsonData.Riepilogo.template.ritenuta_acconto_20 && jsonData.Riepilogo.template.ritenuta_acconto_20.value !== 0) {
        // calcolo differenza imponibile, tenendo conto della ritenuta
        calcoloTotale = differenzaArrotondamento / 1.02
      } else {
        // calcolo differenza imponibile, senza ritenuta
        calcoloTotale = differenzaArrotondamento / 1.22
      }
    } else {
      // se il regime fiscale non è ordinario passiamo la differenza arrotondamento senza calcoli
      calcoloTotale = differenzaArrotondamento;
    }
    return calcoloTotale;
  }

  function calcoloTotalePreventivo(jsonDati){
    let calcoloTotale = 0;
      calcoloTotale = formatterSomma(jsonDati.Riepilogo.template.totale_anticipazioni.value) +
      formatterSomma(jsonDati.Riepilogo.template.totale_imponibile.value) +
      formatterSomma(jsonDati.Riepilogo.template.iva_22.value);

    // Se presente la ritenuta d'acconto dobbiamo sottrarla dal totale calcolato
    if(jsonDati.Riepilogo.template.ritenuta_acconto_20 &&
      jsonDati.Riepilogo.template.ritenuta_acconto_20.value !== 0){
      calcoloTotale -= formatterSomma(templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20.value);
    }
    return calcoloTotale;
  }

  function calcoloCentesimoIva(jsonDati,totalePreventivo){
      let calcoloIva = 0;
      if (jsonDati['Totale Preventivo'].template.arrotondamento.value > totalePreventivo) {
        // Nel caso il valore presente dell'arrotondamento sia maggiore del totale preventivo, al valore dell'iva aggiungiamo un centesimo
        calcoloIva = formatterSomma(templateData.dati_preventivo.Riepilogo.template.iva_22.value) + 0.01
      } else {
        // Nel caso il valore presente dell'arrotondamento sia minore del totale preventivo, al valore dell'iva si sottrae un centesimo
        calcoloIva = formatterSomma(templateData.dati_preventivo.Riepilogo.template.iva_22.value) - 0.01
      }
      return calcoloIva;
  }

  /**
   * Prima di arrotondare se il valore di uno dei due campi dell'equo compenso presenti nella validazione non è vuoto,
   * è stata selezionata una checkbox, dobbiamo togliere la selezione e eliminare il valore dall'input onorari prima di proseguire con i calcoli.
   */
  function resetEquoCompenso(){
      // togliamo la selezione alle checkbox
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = '';
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = '';
      //rimuovo il valore
      templateData.dati_preventivo['Imponibili'].template.onorari.value = '';
      categorieValidazione.preventivo.input.onorari.value = '';
      // assegno il valore vuoto anche alla variabile compensoValoreInziale
      compensoValoreInziale.value = formatterSomma(categorieValidazione.preventivo.input.onorari.value);
      // riporto il totale preventivo al valore iniziale, in questo modo viene triggerato il watch e ricalcola il tutto con il valore di base.
      categorieValidazione.preventivo.input.totale_preventivo_iniziale.value =  totali.totale_preventivo_non_modificabile;
      templateData.dati_preventivo['Totale Preventivo'].template.totale_preventivo.value = totali.totale_preventivo_non_modificabile;
  }

  function arrotondaCompenso() {

    if (validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value != '' ||
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value != '') {
      resetEquoCompenso();
    }
    //
    totaleImponibileCalcolato.value = templateData.dati_preventivo.Riepilogo.template.totale_imponibile.value;

    // Arrotondamento compenso
    let calcoloImponibili = calcoloTotaleImponibiliDaCompenso(templateData.dati_preventivo,compensoValoreInziale);
    let differenza = 0;
    if (calcoloImponibili > formatterSomma(totaleImponibileCalcolato.value )) {
      // nel caso l'arrotondamento inserito sia minore del totale imponibile preventivo
      arrotondamentoCompensoMaggiore.value = false;
      differenza = calcoloImponibili - formatterSomma(totaleImponibileCalcolato.value );
      validazioneArrotondamento.input.arrotondamento_su_compenso.value = differenza;
      let calcolo = formatterSomma(compensoValoreInziale.value) - differenza;
      if (calcolo < 0) {
        FallcoNotify.error('L\'arrotondamento del compenso non può essere un valore negativo');
        // modificare l'input hidden permette di ricalcolare i dati del preventivo come inzialmente impostati
        categorieValidazione.preventivo.input.inputHidden.value = 1;
        // resetta tutti i valori precedentemente modificati con l'inserimento di un valore nell'arrotondamento
        resetArrotondamento()
        return
      } else {
        // Variabile che indica che è necessario aggiornato il valore del compenso perchè modificato l'arrotondamento
        compensoDaAggiornareDaArrotondamento.value = true;
        categorieValidazione.preventivo.input.onorari.value = calcolo;
      }
    } else {
      // nel caso l'arrotondamento inserito sia maggiore del totale imponibile
      arrotondamentoCompensoMaggiore.value = true;
      differenza = formatterSomma(totaleImponibileCalcolato.value ) - calcoloImponibili;
      validazioneArrotondamento.input.arrotondamento_su_compenso.value = differenza;
      compensoDaAggiornareDaArrotondamento.value = true;
      categorieValidazione.preventivo.input.onorari.value = formatterSomma(compensoValoreInziale.value) + differenza
    }
    // Riportiamo il valore della validazione dell'arrotondmaento sul json da salvare e inviare per la stampa
    templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento_su_compenso.value = validazioneArrotondamento.input.arrotondamento_su_compenso.value;
  }

  function calcolaTotaleImponibile(){
    let totale = formatterSomma(templateData.dati_preventivo['Imponibili'].template.cassa_nazionale_notariato ? templateData.dati_preventivo['Imponibili'].template.cassa_nazionale_notariato.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.iscrizione_repertorio ? templateData.dati_preventivo['Imponibili'].template.iscrizione_repertorio.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.visura_ipotecaria ? templateData.dati_preventivo['Imponibili'].template.visura_ipotecaria.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.onorari ? templateData.dati_preventivo['Imponibili'].template.onorari.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.diritti ? templateData.dati_preventivo['Imponibili'].template.diritti.value : 0) -
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.sconto ? templateData.dati_preventivo['Imponibili'].template.sconto.value : 0);
    return totale;
  }

  function calcolaTotaleImponibileCompensoInserito(){
    let totale = formatterSomma(templateData.dati_preventivo['Imponibili'].template.cassa_nazionale_notariato ? templateData.dati_preventivo['Imponibili'].template.cassa_nazionale_notariato.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.iscrizione_repertorio ? templateData.dati_preventivo['Imponibili'].template.iscrizione_repertorio.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.visura_ipotecaria ? templateData.dati_preventivo['Imponibili'].template.visura_ipotecaria.value : 0) +
      formatterSomma(compensoValoreInziale.value ? compensoValoreInziale.value : 0) +
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.diritti ? templateData.dati_preventivo['Imponibili'].template.diritti.value : 0) -
      formatterSomma(templateData.dati_preventivo['Imponibili'].template.sconto ? templateData.dati_preventivo['Imponibili'].template.sconto.value : 0);
    return totale;
  }

  function calcoloTotaleAnticipazioniDirittoAnnuale() {
    // calcola il totale anticipazioni utilizzando sempre dal totale iniziale e aggiornando con i valori presenti negli input
    let totaleAnticipazioniSenzaDirittiiniziali = totali.totale_anticipazioni - categorieValidazione.preventivo.input.diritto_annuale_registro_imprese_valore_iniziale.value
    let dirittoAnnualeRegistroImprese = controlloFormatoDiCalcoloWatch(templateData.dati_preventivo.Anticipazioni.template.diritto_annuale_registro_imprese);
    let altreSpese = controlloFormatoDiCalcoloWatch(templateData.dati_preventivo.Anticipazioni.template.altre_spese);
    let totaleAnticipazioni = totaleAnticipazioniSenzaDirittiiniziali + dirittoAnnualeRegistroImprese + altreSpese;
    return totaleAnticipazioni
  }

  function getUrlParam(param){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = urlParams.get(param);
    return params
  }

  async function getDataPreventivo(urlId,urlDuplica){
    let preventivo;
    preventivo = await httpPost('Preventivi', 'getDataPreventivoById', {id: urlId}, {
      messages: 'error',
    });

    if (preventivo.esito == 'ok') {
      codiceRiferimentoPreventivo.value = 'Riferimento: '+preventivo.data.numero + '/' + preventivo.data.anno;
      if (urlDuplica) {
        datiPreventivoDuplica.value = preventivo;
      } else {
        datiPreventivoReadonly.value = preventivo;
      }
    }
  }

  async function downloadPdfPreventivo(id){
    let dowloadPdf = await httpPost('Storico_preventivi', 'downloadPdf', {preventivo_id: id}, {
      messages: 'error',
    });
    if (dowloadPdf.esito == 'ok') {
      generateDownloadLink(dowloadPdf.pdf, 'Preventivo_'+dowloadPdf.numero+'_'+dowloadPdf.anno);
    }
  }

  /**
   * Funzione che genera le options per il select equo compenso
   * @param item
   * @returns {[{name: string, value: number}]}
   */
  function updateCompensoDaSelectEquoCompenso(event){
    if(event.target.checked && event.target.name == 'valore_equo_compenso_calcolato'){
      categorieValidazione.preventivo.input.onorari.value = valore_equo_compenso_calcolato.value;
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = '';
    } else if(event.target.checked && event.target.name == 'valore_equo_compenso_calcolato_spese_generali') {
      categorieValidazione.preventivo.input.onorari.value = valore_equo_compenso_calcolato_spese_generali.value;
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = '';
    } else {
      categorieValidazione.preventivo.input.onorari.value = '';
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = '';
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = '';
    }

    compensoValoreInziale.value = formatterSomma(categorieValidazione.preventivo.input.onorari.value)
    compensoModificato.value = true;
    resetArrotondamento();
  }

  function setCompensoInizale(e) {
    if (validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value != '' ||
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value != '') {
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato.value = '';
      validazioneEquoCompenso.input.valore_equo_compenso_calcolato_spese_generali.value = '';
    }
    compensoValoreInziale.value = formatterSomma(stringToNumber(typeof e.target.value == 'string' ? e.target.value.replace('€', '') : e.target.value))
    compensoModificato.value = true;
    if (templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value != '' && templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value != 0) {
      resetArrotondamento();
    }
  }

  function resetArrotondamento (event) {
    // al change di tutti i campi editabili mi assicuro che il valore dell'arrotondamento sia vuoto,
    // è un dato da inserire alla fine del calcolo preventivo
    templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value = ''
    templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento_su_compenso.value = ''
    categorieValidazione.preventivo.input.totale_preventivo_iniziale.value = '';
    categorieValidazione.preventivo.input.onorari.value = compensoValoreInziale.value;
    validazioneArrotondamento.input.arrotondamento.value = ''
    validazioneArrotondamento.input.arrotondamento_su_compenso.value = ''
    arrotondamentoCalcolato.value = false
  }

  function calcoloDifferenzaArrotondamento () {
    let value = 0;
    let valore_arrotondamento_obj = validazioneArrotondamento.input.arrotondamento;

    // Valore passato dal change del campo arrotondamento (cliccando enter o altro tasto,
    // il valore non arriva formattato correttamente, correggo il valore da stringa a numero)
    if(validazioneArrotondamento.input.arrotondamento.value.toString().includes('.') &&
       validazioneArrotondamento.input.arrotondamento.value.toString().includes('€')){
      valore_arrotondamento_obj.value = stringToNumber(validazioneArrotondamento.input.arrotondamento.value.toString())
    }

    let valoreArrotondamento = controlloFormatoDiCalcoloWatch(valore_arrotondamento_obj)
    let valoreTotale = controlloFormatoDiCalcoloWatch(templateData.dati_preventivo['Totale Preventivo'].template.totale_preventivo)
    if (valoreArrotondamento > valoreTotale) {
      value = valoreArrotondamento - valoreTotale;
      arrotondamentoMaggioreDelTotale.value = true
    } else {
      value = valoreTotale - valoreArrotondamento;
      arrotondamentoMaggioreDelTotale.value = false
    }

    return formatterSomma(value)
  }

  /**
   * Funzione che viene richiamata al change del campo arrotondamento e aggiorna i vari input
   * @param event
   */
  function calcoloArrotondamento (event,regime_fiscale) {
    ricalcoloPreventivoGenerato.value = false;
    // controlla che il il valore del campo arrotondamento non sia una stringa e in caso rimuove il carattere €
    let valoreArrotondamento = event.target.value;
    valoreArrotondamento = valoreArrotondamento.replace('€', '');
    valoreArrotondamento = valoreArrotondamento.trim();
    valoreArrotondamento = stringToNumber(valoreArrotondamento);
    let arrotondamento = valoreArrotondamento;

    // se il valore del totale preventivo iniziale non è definito andiamo a salvare il totale preventivo attuale,
    // prima di applicare le modifiche, serve per applicare i diversi calcoli avendo sempre il totale inziale originale
    if(categorieValidazione.preventivo.input.totale_preventivo_iniziale.value == '') {
      categorieValidazione.preventivo.input.totale_preventivo_iniziale.value = controlloFormatoDiCalcoloWatch(templateData.dati_preventivo['Totale Preventivo'].template.totale_preventivo)
    }

    // Se il campo arrotondamento ha un valore, modifica il totale preventivo, il totale imponibile, l'iva e se presente la ritenuta
    if (arrotondamento != 0) {
      arrotondamentoCalcolato.value = false
      let differenzaImponibile = 0
      let totaleImponibile = 0
      let differenzaArrotondamento = 0;

      // controllo se il dato è un numero, altrimento lo imposto a zero
      if (isNaN(arrotondamento)) {
        arrotondamento = 0
      }

      // Avviso - L'arrotondamento non può essere inferiore alla somma dei valori (totale anticipazioni)
      if (arrotondamento < templateData.dati_preventivo.Riepilogo.template.totale_anticipazioni.value) {
        FallcoNotify.error('L\'arrotondamento non può essere inferiore alla somma dei valori');
        // modificare il valore dell'input hidden richiama il watch su categorieValidazione
        // e permette di ricalcolare i dati del preventivo come inzialmente impostati
        categorieValidazione.preventivo.input.inputHidden.value = 1;
        resetArrotondamento()
        return
      }

      // Aggiorno nel json il totale preventivo con il valore dell'arrotondamento
      templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value = arrotondamento

      // Calcola la differenza tra totale preventivo e arrotondamento
      differenzaArrotondamento = calcoloDifferenzaArrotondamento();

      // Calcola la differenza tra totale imponibile e arrotondamento
      differenzaImponibile = calcoloDifferenzaImponibile(templateData.dati_preventivo, differenzaArrotondamento,regime_fiscale);

      // Calcola il totale imponibile, se inserito il compenso lo aggiunge alla somma
      totaleImponibile = calcolaTotaleImponibileCompensoInserito();

      // Aggiorna il totale imponibile, controllando se arrotondamento è maggiore o minore del totale
      if (arrotondamentoMaggioreDelTotale.value == true) {
        totaleImponibile = formatterSomma(totaleImponibile) + formatterSomma(differenzaImponibile)
      } else {
        totaleImponibile = formatterSomma(totaleImponibile) - formatterSomma(differenzaImponibile)
      }

      // Aggiorna l'oggetto del preventivo nel totale imponibile con il nuovo valore
      templateData.dati_preventivo.Riepilogo.template.totale_imponibile.value = totaleImponibile;

      // Aggiorna IVA
      if(regime_fiscale === 'ordinario') {
        templateData.dati_preventivo.Riepilogo.template.iva_22.value = (totaleImponibile * 22) / 100;
      } else {
        templateData.dati_preventivo.Riepilogo.template.iva_22.value = 0;
      }

      // Se presente calcola e aggiorna la ritenuta (20%)
      if(regime_fiscale === 'ordinario') {
        if (templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20 &&
          templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20.value !== 0) {
          templateData.dati_preventivo.Riepilogo.template.ritenuta_acconto_20.value = (totaleImponibile * 20) / 100
        }
      }

      // Calcolo il totale con i dati presenti nel json per poi aggiornarlo/confrontarlo
      let totalePreventivo = calcoloTotalePreventivo(templateData.dati_preventivo);

      // Se il totale preventivo è differente dall'arrotondamento correggo l'errore del centesimo (0.01), modificando il valore dell'iva
      if(regime_fiscale === 'ordinario') {
        // chiedere
        if (totalePreventivo != templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value) {
          templateData.dati_preventivo.Riepilogo.template.iva_22.value = calcoloCentesimoIva(templateData.dati_preventivo, totalePreventivo);
        }
      }

      // Quando l'arrotondamento è calcolato, chiama la funzione per aggiornare il campo compenso (visibile nel dettaglio preventivo)
      arrotondaCompenso();

    } else {
      // Se il campo arrotondamento è vuoto, reset valore arrotondamento, arrotondamento su compenso e ripristino valore iniziare compenso
      // utilizza l'input hidden per richiamare il watch del dettaglio preventivo e ricalcolare il tutto con i valori aggiornati
      let valoreInzialeCompenso = compensoValoreInziale.value;
      validazioneArrotondamento.input.arrotondamento_su_compenso.value = 0;
      categorieValidazione.preventivo.input.onorari.value = valoreInzialeCompenso;
      arrotondamentoCalcolato.value = false;
      templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value = ''
      templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento_su_compenso.value = ''
      categorieValidazione.preventivo.input.inputHidden.value = 1
    }

    // Aggiorna la variabile di arrotondamentoCalcolato che viene utilizzata per mostrare/nascondere
    // nel dettaglio preventivo la differenza tra il totale e l'arrotondamento (tra parentesi nella voce dettaglio preventivo)
    if (templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value != 0 &&
      templateData.dati_preventivo['Totale Preventivo'].template.arrotondamento.value != '') {
      arrotondamentoCalcolato.value = true
    } else {
      arrotondamentoCalcolato.value = false
    }
  }

  function aggiornaTestoCompilazione (e) {
    testoCompilazione.value = e
  }

  // Funzione per caricarare il corretto helper in base al preventivo selezionato
  function getHelperSezione(index){
    let sezioneHelper = '';
    switch (index) {
      case 'Anticipazioni':
        sezioneHelper = DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni.anticipazioni.ref
        break
      case 'Parametri di Calcolo':
        sezioneHelper = DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni.parametri.ref
        break
      case 'Imponibili':
        sezioneHelper = DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni.imponibili.ref
        break
      case 'Riepilogo':
        sezioneHelper = DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni.riepilogo.ref
        break
      case 'Condizioni':
        sezioneHelper = DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni.condizioni.ref
        break
    }
    return sezioneHelper
  }

  function calcoloArrotondamentoClickOutside(event, regimeFiscale) {
    let save_value = event.target.value;
    event.target.value = 0;
    event.target.value = save_value;
    procediAlCalcoloArrotondamento.value = true;
    event.target.dispatchEvent(new Event('change'))
  }
  function arrotondamentoEnterKey(event){
    if (event.keyCode === 13 && event.target.nodeName === 'INPUT') {
      var form = event.target.form;
      var index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  }

  return {
    formVisible,
    regimeFiscale,
    editMode,
    preventivoCalcolato,
    validazioneForm,
    templateData,
    cardPreventivi,
    categoriaImmobiliare,
    copiaCategoriaImmobiliare,
    categoriaSocietario,
    copiaCategoriaSocietario,
    categoriaFamiglia,
    copiaCategoriaFamiglia,
    categoriaAttiMortisCausa,
    copiaCategoriaAttiMortisCausa,
    categoriaAltro,
    copiaCategoriaAltro,
    preventivo,
    categorieValidazione,
    totali,
    preventivoTabsJSONData,
    inputFiltro,
    renditaCatastale,
    validazioneAltreSpese,
    validazioneAltriImponibili,
    renditaCatastaleTerreno,
    onorarioRepertorio,
    esito,
    validazioneArrotondamento,
    readonlyStatus,
    idPreventivo,
    ricalcoloPreventivoGenerato,
    codiceRiferimentoPreventivo,
    alertRicalcolo,
    validazioneCondizioni,
    validazioneEquoCompenso,
    valore_equo_compenso_calcolato_spese_generali,
    valore_equo_compenso_calcolato,
    valoreCompensoPrecedente,
    compensoValoreInziale,
    arrotondamentoCompensoMaggiore,
    arrotondamentoMaggioreDelTotale,
    arrotondamentoCalcolato,
    totaleImponibileCalcolato,
    compensoModificato,
    compensoDaAggiornareDaArrotondamento,
    duplicaStatus,
    datiPreventivoDuplica,
    datiPreventivoReadonly,
    testoCompilazione,
    condizioniRequired,
    tabellaEquoCompensoSelezionata,
    procediAlCalcoloArrotondamento,
    formattaStringaPercentuale,
    onSubmittedForm,
    onResetForm,
    openForm,
    formatterValore,
    formatterSomma,
    codifica_valore,
    decodifica_valore,
    disabilitaRisultaticalcolo,
    getCopiaCategoria,
    getLabelItem,
    stringToNumber,
    getComponentName,
    updateDatiCalcolo,
    salvaPreventivo,
    formatterValoreAliquota,
    aggiornaJsonDaInputDettaglioPreventivo,
    calcoloTotaleAnticipazioniEdit,
    calcoloTotaleImponibili,
    calcoloIvaTotaleImponibile,
    calcoloRitenutaAcconto,
    controlloFormatoDiCalcoloWatch,
    aggiornamentoDatiPreventivo,
    calcoloDifferenzaImponibile,
    calcoloTotalePreventivo,
    calcoloCentesimoIva,
    arrotondaCompenso,
    getUrlParam,
    calcoloTotaleAnticipazioniDirittoAnnuale,
    calcolaTotaleImponibileCompensoInserito,
    calcolaTotaleImponibile,
    updateCompensoDaSelectEquoCompenso,
    downloadPdfPreventivo,
    getDataPreventivo,
    setCompensoInizale,
    resetArrotondamento,
    calcoloDifferenzaArrotondamento,
    calcoloArrotondamento,
    aggiornaTestoCompilazione,
    getHelperSezione,
    calcoloArrotondamentoClickOutside,
    arrotondamentoEnterKey
  }
}